// src/features/auth/authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserData {
  _id: string;
  name: string;
  email: string;
  role: number[];
  counselor_id: string | null;
  source_id: string | null;
  department_id: string | null;
  is_verify: boolean;
  is_banned: boolean;
  status: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

interface AuthState {
    isAuthenticated: boolean;
    token: string | null;
    user: UserData | null;
    loading: boolean;
    error: string | null;
}

const initialState: AuthState = {
    isAuthenticated: false,
    token: null,
    user: null,
    loading: false,
    error: null
}
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginStart(state) {
            state.loading = true;
            state.error = null;
        },
        loginSuccess(state, action: PayloadAction<{token: string, user: UserData}>) {
            state.isAuthenticated = true;
            state.token = action.payload.token;
            state.user = action.payload.user;
            state.loading = false;
            localStorage.setItem('token', action.payload.token);
        },
        loginFailure(state, action: PayloadAction<string>) {
            state.loading = false;
            state.error = action.payload;
        },
        setUser(state, action: PayloadAction<UserData>) {
            state.user = action.payload;
            state.isAuthenticated = true;
        },
        logout(state) {
            state.isAuthenticated = false;
            state.token = null;
            state.user = null;
            localStorage.removeItem('token');
        },
    },
})

export const { loginStart, loginSuccess, loginFailure, setUser, logout } = authSlice.actions;
export default authSlice.reducer;
